import { GetDemands } from "event-definitions"

GetDemands.handleOnce(({ demands }) => {
    demands.push(...(window._authorization?.demands ?? []))
})
